/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function EditDrawing({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#EditDrawing_svg__a)"><path fillRule="evenodd" d="M14.032.98a2.6 2.6 0 0 0-3.552.952L5.953 9.774a2.6 2.6 0 0 0-.342 1.482l.239 3.401a.6.6 0 0 0 .861.498l3.066-1.494a2.6 2.6 0 0 0 1.112-1.037l4.528-7.842a2.6 2.6 0 0 0-.952-3.552zM11.52 2.532a1.4 1.4 0 0 1 1.912-.512l.433.25a1.4 1.4 0 0 1 .512 1.912l-4.2 7.275-2.857-1.65zm-4.705 8.37q-.016.134-.007.27l.177 2.515 2.266-1.105q.123-.06.23-.141z" clipRule="evenodd" /><path d="M5.085 14.02a.6.6 0 0 1-.718.453A5.1 5.1 0 0 1 .4 9.5v-.003q0-.504.098-.992a.6.6 0 1 1 1.177.234Q1.6 9.114 1.6 9.5v.003a3.9 3.9 0 0 0 3.033 3.8.6.6 0 0 1 .452.718M5.5 5.6a.6.6 0 1 0 0-1.2 5 5 0 0 0-.995.098.6.6 0 0 0 .234 1.177Q5.114 5.6 5.5 5.6M3.333 6.257a.6.6 0 0 0-.666-.998A5.1 5.1 0 0 0 1.26 6.667a.6.6 0 1 0 .997.666 3.9 3.9 0 0 1 1.076-1.076" /></g><defs><clipPath id="EditDrawing_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;